module.exports = __webpack_public_path__ + "static/img/ok1.120c332.png";